/* Mōushi — Interactions (Shopify) */

/* Scroll natif restauré — le scroll-jacking (wheel/keydown) a été retiré pour l'accessibilité et la fluidité. */

(function () {

  /* ============================================================
     NAVBAR
  ============================================================ */
  var nav      = document.querySelector('.nav');
  var heroWrap = document.querySelector('.hero-wrap');

  function updateNav() {
    if (!nav) return;
    if (!heroWrap) {
      nav.classList.add('scrolled');
      nav.classList.remove('on-hero');
      return;
    }
    // Bascule ivoire quand la section suivante commence à recouvrir le hero fixe.
    var threshold = Math.max(24, heroWrap.offsetHeight - window.innerHeight - 40);
    if (window.scrollY > threshold) {
      nav.classList.add('scrolled');
      nav.classList.remove('on-hero');
    } else {
      nav.classList.add('on-hero');
      nav.classList.remove('scrolled');
    }
  }
  window.addEventListener('scroll', updateNav, { passive: true });
  updateNav();

  /* ============================================================
     PANIER — Shopify AJAX API
  ============================================================ */

  function loadCart(callback) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(callback)
      .catch(function () { callback({ items: [], item_count: 0, total_price: 0 }); });
  }

  function addToCart(variantId, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function () { return fetch('/cart.js'); })
    .then(function (r) { return r.json(); })
    .then(callback)
    .catch(function (err) { console.error('Cart error:', err); });
  }

  function changeItem(key, qty, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(callback)
    .catch(function (err) { console.error('Cart error:', err); });
  }

  function refreshCartBadge(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.classList.toggle('visible', count > 0);
    });
  }

  /* ---- Toast ---- */
  function showToast(msg) {
    var t = document.querySelector('.cart-toast');
    if (t) t.remove();
    t = document.createElement('div');
    t.className   = 'cart-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add('visible'); }); });
    setTimeout(function () { t.classList.remove('visible'); setTimeout(function () { t.remove(); }, 400); }, 2800);
  }

  /* ---- Boutons "Ajouter au panier" ---- */
  document.querySelectorAll('.btn-cart').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = this.dataset.variantId;
      if (!variantId) return;

      var orig = this.textContent;
      var self = this;
      this.textContent = 'Ajouté ✓';
      this.disabled    = true;
      this.classList.add('btn-added');

      addToCart(variantId, function (cart) {
        refreshCartBadge(cart.item_count);
        openCart();
        setTimeout(function () {
          self.textContent = orig;
          self.disabled    = false;
          self.classList.remove('btn-added');
        }, 2000);
      });
    });
  });

  /* Charge le badge au chargement de la page */
  loadCart(function (cart) {
    refreshCartBadge(cart.item_count);
  });

  /* ============================================================
     CART DRAWER
  ============================================================ */

  function openCart() {
    var drawer  = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartOverlay');
    if (!drawer) return;

    loadCart(function (cart) {
      renderCartDrawer(cart);
      refreshCartBadge(cart.item_count);
    });

    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('active');
    var sy = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top      = '-' + sy + 'px';
    document.body.style.width    = '100%';
    document.body.dataset.scrollY = sy;
  }

  function closeCart() {
    var drawer  = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartOverlay');
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('active');
    var sy = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    window.scrollTo(0, sy);
  }

  function renderCartDrawer(cart) {
    var body = document.getElementById('cartBody');
    var foot = document.getElementById('cartFoot');
    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="cart-empty">' +
          '<p>Votre panier est vide.</p>' +
          '<a class="btn btn-ghost" href="/pages/the-ritual">Découvrir Not Coffee</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image || window.moushiProductImg || '';
      html +=
        '<div class="cart-item">' +
          '<img class="cart-item-img" src="' + img + '" alt="' + item.product_title + '">' +
          '<div class="cart-item-info">' +
            '<p class="cart-item-name">' + item.product_title + '</p>' +
            '<p class="cart-item-price">€' + (item.final_price / 100).toFixed(2) + '</p>' +
            '<div class="cart-item-row">' +
              '<div class="cart-item-controls">' +
                '<button class="cart-qty-btn" data-action="qty" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">&#8722;</button>' +
                '<span class="cart-qty-val">' + item.quantity + '</span>' +
                '<button class="cart-qty-btn" data-action="qty" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
              '</div>' +
              '<button class="cart-item-remove" data-action="remove" data-key="' + item.key + '">Retirer</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    body.innerHTML = html;

    if (foot) {
      foot.hidden = false;
      var el = document.getElementById('cartTotal');
      if (el) el.textContent = '€' + (cart.total_price / 100).toFixed(2);
    }
  }

  /* Délégation — qty & remove */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    if (btn.dataset.action === 'qty') {
      changeItem(btn.dataset.key, parseInt(btn.dataset.qty, 10), function (cart) {
        renderCartDrawer(cart);
        refreshCartBadge(cart.item_count);
      });
    }
    if (btn.dataset.action === 'remove') {
      changeItem(btn.dataset.key, 0, function (cart) {
        renderCartDrawer(cart);
        refreshCartBadge(cart.item_count);
      });
    }
  });

  document.querySelectorAll('.open-cart').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });

  var overlay = document.getElementById('cartOverlay');
  if (overlay) overlay.addEventListener('click', closeCart);

  var closeBtn = document.getElementById('cartClose');
  if (closeBtn) closeBtn.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  var checkoutBtn = document.getElementById('cartCheckout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }

  /* ============================================================
     RITUAL PAGE — recession scrub
  ============================================================ */
  var productWrap = document.querySelector('.product-wrap');
  if (productWrap) {
    var productHero = productWrap.querySelector('.product');
    var wrapTop = productWrap.getBoundingClientRect().top + window.scrollY;
    function recedeTick() {
      var p = Math.min(1, Math.max(0, (window.scrollY - wrapTop) / window.innerHeight));
      productHero.style.transform = 'scale(' + (1 - p * 0.08) + ') translateZ(0)';
      productHero.style.opacity   = String(1 - p * 0.40);
      requestAnimationFrame(recedeTick);
    }
    requestAnimationFrame(recedeTick);
  }

  /* ============================================================
     JOURNAL — FILTRES PAR CATÉGORIE
  ============================================================ */
  var filterLinks = document.querySelectorAll('.journal-filters a[data-filter]');
  if (filterLinks.length) {
    filterLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        filterLinks.forEach(function (l) { l.classList.remove('is-active'); });
        this.classList.add('is-active');
        var tag = this.dataset.filter;
        document.querySelectorAll('.journal-card').forEach(function (card) {
          card.classList.toggle('filter-hidden', tag !== 'all' && card.dataset.category !== tag);
        });
      });
    });
  }

  /* ============================================================
     POWDER CANVAS
  ============================================================ */
  (function () {
    var canvas = document.getElementById('powderCanvas');
    if (!canvas) return;

    var ctx      = canvas.getContext('2d');
    var W = 0, H = 0;
    var particles = [];
    var started   = false;

    var PALETTE = [
      [166, 138, 124],
      [190, 155, 132],
      [142, 108,  90],
      [208, 178, 152],
    ];

    function resize() {
      var dpr  = window.devicePixelRatio || 1;
      var rect = canvas.getBoundingClientRect();
      W = rect.width;
      H = rect.height;
      canvas.width  = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function spawn() {
      var col = PALETTE[Math.floor(Math.random() * PALETTE.length)];
      return {
        x: Math.random() * W, y: Math.random() * H,
        r: Math.random() * 2.2 + 0.5,
        alpha: Math.random() * 0.42 + 0.06,
        vy: -(Math.random() * 0.28 + 0.07),
        vx: (Math.random() - 0.5) * 0.22,
        phase: Math.random() * Math.PI * 2,
        col: col,
      };
    }

    function init() {
      resize();
      particles = [];
      for (var i = 0; i < 44; i++) particles.push(spawn());
    }

    function frame() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.phase += 0.010;
        p.x += p.vx + Math.sin(p.phase) * 0.18;
        p.y += p.vy;
        if (p.y < -p.r * 2) { p.y = H + p.r * 2; p.x = Math.random() * W; }
        if (p.x < -p.r * 2)   p.x = W + p.r * 2;
        if (p.x > W + p.r * 2) p.x = -p.r * 2;
        var fx   = Math.min(p.x / (W * 0.12), (W - p.x) / (W * 0.12), 1);
        var fy   = Math.min(p.y / (H * 0.12), (H - p.y) / (H * 0.12), 1);
        var fade = Math.max(0, Math.min(fx, fy, 1));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(' + p.col[0] + ',' + p.col[1] + ',' + p.col[2] + ','
                        + (p.alpha * fade).toFixed(3) + ')';
        ctx.fill();
      }
      requestAnimationFrame(frame);
    }

    function start() {
      if (started) return;
      started = true;
      init();
      frame();
    }

    window.addEventListener('resize', function () { init(); });

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      start();
    } else {
      window.addEventListener('load', start);
    }
  }());

  /* ============================================================
     HERO VIDEO — lecture unique + respect du mouvement réduit
  ============================================================ */
  (function () {
    var v = document.querySelector('.hero-video');
    if (!v) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduce.matches) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
      return; /* le poster reste affiché, aucune animation */
    }

    function tryPlay() {
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          /* Autoplay bloqué (iOS Low Power…) : on joue au 1er geste. */
          var once = function () {
            v.play();
            document.removeEventListener('touchend', once);
            document.removeEventListener('click', once);
          };
          document.addEventListener('touchend', once, { passive: true });
          document.addEventListener('click', once, { passive: true });
        });
      }
    }

    tryPlay();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tryPlay();
    });
  }());

  /* ============================================================
     COMMUNITY — clip-path expand on scroll
  ============================================================ */
  (function () {
    var section = document.querySelector('.community-wrap');
    if (!section) return;
    if (window.matchMedia('(max-width: 768px)').matches) return;

    var ticking = false;

    function update() {
      ticking = false;
      var rect     = section.getBoundingClientRect();
      var vh       = window.innerHeight;
      var raw      = (vh - rect.top) / (vh * 0.75);
      var progress = Math.min(1, Math.max(0, raw));
      var e        = 1 - Math.pow(1 - progress, 2);
      var inY = ((1 - e) * vh * 0.10).toFixed(1);
      var inX = ((1 - e) * window.innerWidth * 0.14).toFixed(1);
      var r   = ((1 - e) * 22).toFixed(1);
      section.style.clipPath = 'inset(' + inY + 'px ' + inX + 'px round ' + r + 'px)';
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });

    update();
  }());

  /* ============================================================
     SCROLL REVEAL
  ============================================================ */
  var revealSelectors = [
    '.about-split-text', '.about-split-image',
    '.ritual-head', '.ritual-step',
    '.product-text', '.product-image',
    '.formula-row', '.formula-promise-inner',
    '.journal-featured-inner', '.journal-grid-head',
    '.journal-card', '.journal-hero-inner',
  ];

  revealSelectors.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (el, i) {
      el.classList.add('reveal');
      var staggered = ['.ritual-step', '.journal-card', '.formula-row'];
      if (staggered.indexOf(selector) !== -1) {
        el.style.transitionDelay = (i * 0.08) + 's';
      }
    });
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });

  document.querySelectorAll('.reveal').forEach(function (el) { observer.observe(el); });

})();

/* ============================================================
   FOOTER REVEAL
============================================================ */
(function () {
  var hero         = document.querySelector('.hero');
  var footerSpacer = document.querySelector('.footer-spacer');
  if (!hero || !footerSpacer) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        hero.style.opacity       = '0';
        hero.style.pointerEvents = 'none';
      } else {
        hero.style.opacity       = '';
        hero.style.pointerEvents = '';
      }
    });
  }, { threshold: 0 });

  io.observe(footerSpacer);
}());
